<template>
  <div class="signup-container">
    <v-row cols="12" class="mb-6">
      <v-col>
        <div class="signup-logo">
          <v-img :src="require('../assets/join-us.jpeg')" height="179"/>
        </div>
      </v-col>
      <v-col cols="7" class="signup-panel pa-5">
        <v-row class="pl-7">
          <h2 style="font-size: 23.5px;" >Welcome to the Clarence community.</h2>
          <p style="font-size: 17px; font-weight: 500;">We have sent you a welcome email to your email address.</p>
          <p>If you do not receive a welcome email, please check your spam/junk folder. </p>
          <p>If you need assistance, please <a href="https://clarenceprofessionalgroup.com.au/contact/">contact us</a>.</p>
        </v-row>
        <v-row class="pl-7">
          <v-col>
            <v-btn class="float-right" large link href="https://clarenceprofessionalgroup.com.au/" color="primary">HOME</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
}
</script>
<style scoped>
  .signup-container {
    margin: auto;
    padding: 20px;
    background-color: #f1eeee;
    max-width: 960px;
    font-family: Helvetica Neue For Number,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0,0,0,.65);
  }
  .signup-panel {
    border-left: 2px solid #000;
  }
  .signup-logo {
    margin: 0 auto;
    width: 275px;
    height: 179px;
  }
  .signup-progress {
    font-weight: 400;
    font-size: 20px;
    text-align: center;
  }
  .progress {
    margin: 10px 0px;
    display: block;
  }
  h1, h2, h3, h4, h5, h6 {
      margin-top: 0;
      margin-bottom: .5em;
      color: rgba(0,0,0,.85);
      font-weight: 500 !important;
  }
  .sidebar-title {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    font-family: Helvetica Neue For Number,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;
    text-align: center;
  }
</style>

